const initBlogArticleDesign = () => {
  const loadMoreButton = document.querySelector('.blog-articles-container .blog-articles-container__loadmore-text');

  const getMoreArticles = () => {
    const sectionContainer = document.querySelector('.blog-articles-container');
    let renderedArticlesCount = Number(sectionContainer.querySelectorAll('.article-container').length);
    let {templateSuffix, themeRole, articlesSize} = sectionContainer.dataset;
    const nextPage = Math.floor((renderedArticlesCount / 6) + 1);
    let url = `/blogs/${templateSuffix}?view=${themeRole === 'main' ? '' : templateSuffix}&page=${nextPage}`;

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const newContent = parser.parseFromString(html, 'text/html');
        const newArticles = newContent.querySelectorAll('.article-container');
        let totalArticles= renderedArticlesCount + newArticles.length;
        if (totalArticles > articlesSize) {
          loadMoreButton.style.display = 'none';
          let difference = totalArticles - articlesSize;
          for (let i = 0; i < difference; i++) {
            sectionContainer.querySelector('.blog-articles-container__list').append(newArticles[i]);
          }
        } else {
          sectionContainer.querySelector('.blog-articles-container__list').append(...newArticles);
        }
      })
      .catch(error => console.error('CRO: loading more articles', error));
  }

  if (!loadMoreButton) return;
  loadMoreButton.addEventListener('click', () => {
    getMoreArticles();
  });
}

export default initBlogArticleDesign;